import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { getText } from '../../../../utils/util'
import copy from 'copy-to-clipboard'
import { Cell, Dialog } from 'react-vant'
import './index.css'
import { Button } from 'antd'
import { Toast } from 'antd-mobile'
import { useState } from 'react'
import { changeLanguage } from '../../../../i18n/i18n'

export default function CenterPage() {
  const navigate = useNavigate()
  const { t: translate } = useTranslation()
  const lan = localStorage.getItem('i18n')

  const changelan = (languageStr) => {
    //英语
    changeLanguage(languageStr)
    navigate(-1)
  }

  return (
    <div className='min-h-screen bg-neutral-900 p-4 md:p-6'>
      <div className='max-w-4xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 text-white'>
        <div
          className={`${
            lan == 'en'
              ? 'bg-primary bg-opacity-20 border-primary'
              : 'bg-neutral-800 border-transparent hover:bg-neutral-700'
          } cursor-pointer rounded-lg p-4 border transition-all duration-300 ease-in-out hover:shadow-lg`}
          onClick={() => {
            changelan('en')
          }}>
          English
        </div>
        <div
          className={`${
            lan == 'zh'
              ? 'bg-primary bg-opacity-20 border-primary'
              : 'bg-neutral-800 border-transparent hover:bg-neutral-700'
          } cursor-pointer rounded-lg p-4 border transition-all duration-300 ease-in-out hover:shadow-lg`}
          onClick={() => {
            changelan('zh')
          }}>
          繁体中文
        </div>
        <div
          className={`${
            lan == 'ar'
              ? 'bg-primary bg-opacity-20 border-primary'
              : 'bg-neutral-800 border-transparent hover:bg-neutral-700'
          } cursor-pointer rounded-lg p-4 border transition-all duration-300 ease-in-out hover:shadow-lg`}
          onClick={() => {
            changelan('ar')
          }}>
          اللغة العربية
        </div>
        <div
          className={`${
            lan == 'ja'
              ? 'bg-primary bg-opacity-20 border-primary'
              : 'bg-neutral-800 border-transparent hover:bg-neutral-700'
          } cursor-pointer rounded-lg p-4 border transition-all duration-300 ease-in-out hover:shadow-lg`}
          onClick={() => {
            changelan('ja')
          }}>
          日本語
        </div>
        <div
          className={`${
            lan == 'vi'
              ? 'bg-primary bg-opacity-20 border-primary'
              : 'bg-neutral-800 border-transparent hover:bg-neutral-700'
          } cursor-pointer rounded-lg p-4 border transition-all duration-300 ease-in-out hover:shadow-lg`}
          onClick={() => {
            changelan('vi')
          }}>
          Tiếng Việt
        </div>
        <div
          className={`${
            lan == 'es'
              ? 'bg-primary bg-opacity-20 border-primary'
              : 'bg-neutral-800 border-transparent hover:bg-neutral-700'
          } cursor-pointer rounded-lg p-4 border transition-all duration-300 ease-in-out hover:shadow-lg`}
          onClick={() => {
            changelan('es')
          }}>
          Español
        </div>
        <div
          className={`${
            lan == 'de'
              ? 'bg-primary bg-opacity-20 border-primary'
              : 'bg-neutral-800 border-transparent hover:bg-neutral-700'
          } cursor-pointer rounded-lg p-4 border transition-all duration-300 ease-in-out hover:shadow-lg`}
          onClick={() => {
            changelan('de')
          }}>
          Deutsch
        </div>
        <div
          className={`${
            lan == 'fr'
              ? 'bg-primary bg-opacity-20 border-primary'
              : 'bg-neutral-800 border-transparent hover:bg-neutral-700'
          } cursor-pointer rounded-lg p-4 border transition-all duration-300 ease-in-out hover:shadow-lg`}
          onClick={() => {
            changelan('fr')
          }}>
          Français
        </div>
        <div
          className={`${
            lan == 'it'
              ? 'bg-primary bg-opacity-20 border-primary'
              : 'bg-neutral-800 border-transparent hover:bg-neutral-700'
          } cursor-pointer rounded-lg p-4 border transition-all duration-300 ease-in-out hover:shadow-lg`}
          onClick={() => {
            changelan('it')
          }}>
          Italiano
        </div>
        <div
          className={`${
            lan == 'pt'
              ? 'bg-primary bg-opacity-20 border-primary'
              : 'bg-neutral-800 border-transparent hover:bg-neutral-700'
          } cursor-pointer rounded-lg p-4 border transition-all duration-300 ease-in-out hover:shadow-lg`}
          onClick={() => {
            changelan('pt')
          }}>
          Português
        </div>
        <div
          className={`${
            lan == 'ko'
              ? 'bg-primary bg-opacity-20 border-primary'
              : 'bg-neutral-800 border-transparent hover:bg-neutral-700'
          } cursor-pointer rounded-lg p-4 border transition-all duration-300 ease-in-out hover:shadow-lg`}
          onClick={() => {
            changelan('ko')
          }}>
          한국어
        </div>
        <div
          className={`${
            lan == 'tr'
              ? 'bg-primary bg-opacity-20 border-primary'
              : 'bg-neutral-800 border-transparent hover:bg-neutral-700'
          } cursor-pointer rounded-lg p-4 border transition-all duration-300 ease-in-out hover:shadow-lg`}
          onClick={() => {
            changelan('tr')
          }}>
          Türkçe
        </div>
      </div>
    </div>
  )
}
